import { ChipRadioGroup } from "../../../../../core/Chip.js";
import { RadioGroup } from "../../../../../core/RadioGroup.js";
import { Text } from "../../../../../core/Text.js";
import { Toggle } from "../../../../../core/Toggle.js";
import type { BattleSettingsContent } from "../../../battlesContent.js";

/**
 * How the battle plays: how many seats (chips), the mode (tiles, each with its rule) and the
 * switches (private, fast spin, start with bots), each with what it does.
 */
export function BattleSettings({ players, mode, toggles }: BattleSettingsContent) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <Text as="h2" variant="heading-h2" tone="primary">
          {players.label}
        </Text>
        <ChipRadioGroup
          label={players.label}
          value={players.value}
          options={players.options}
          onValueChange={players.onValueChange}
        />
      </div>
      <RadioGroup
        label={mode.label}
        appearance="tiles"
        columns={2}
        value={mode.value}
        options={mode.options}
        onValueChange={mode.onValueChange}
      />
      <ul className="flex flex-col gap-4">
        {toggles.map((toggle) => (
          <li key={toggle.id} className="flex items-center justify-between gap-4">
            <div className="flex min-w-0 flex-col">
              <Text variant="body-b2-strong" tone="primary">
                {toggle.label}
              </Text>
              <Text id={`${toggle.id}-hint`} variant="body-b3" tone="tertiary">
                {toggle.hint}
              </Text>
            </div>
            <Toggle
              label={toggle.label}
              aria-describedby={`${toggle.id}-hint`}
              checked={toggle.checked}
              onCheckedChange={toggle.onCheckedChange}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
